import { Injectable } from '@angular/core';
import { FractionalValue } from 'src/app/components/att-casting-view/formats/fractional-values-sel/fractional-values-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';


@Injectable({
	providedIn: 'root'
})
export class NumberFractionQualifierService implements Qualifier {
	static supportedStats = ['avg', 'count', 'first', 'last', 'max', 'median', 'min', 'sum', 'stddev'];
	static ToHeader(label: string, format: FractionalValue): string {
		switch (format.mode) {
			case 'convert':
				return `${label}`;
			case 'numerator':
				return `${label} x 1/${format.denom}`;
			case 'percent':
				if (format.labelMode === 'value') {
					return label;
				}
				return `${label} %`;
		}
	}
	static ToString(value: number, format: FractionalValue, fixed?: number): string {
		const config = {}
		
		if ('' + value === '') {
			return '';
		}
		const denom = +format.denom;
		switch (format.mode) {
			case 'convert':
				/* if (('' + value).substr(0, 2) === '16') {
					console.log(value);
				}*/
				const modulusNumber = (Number(value) % Number(denom));
				let modulusString = '' + modulusNumber;
				if ([undefined, null].indexOf(fixed) < 0) {
					if (modulusString !== '0') {
						modulusString = modulusNumber.toFixed(fixed)
					}
				}
				const whole = Math.floor(Number(value) / Number(denom));
				const wholeStr = (whole === 0) ? '' : '' + whole;

				let fraction = '';
				// if ((modulusString === '0') && (format.labelMode === 'label')) {
				//	fraction = '';
				//} else {
				fraction = ` ${modulusString}/${denom}`;
				//}

				return `${wholeStr}${fraction}`;
			case 'numerator':
				return '' +
					(([undefined, null].indexOf(fixed) < 0) ?
						Number(value).toFixed(fixed) + ((format.labelMode === 'label') ? '' : ' x 1/' + denom) :
						(value + ((format.labelMode === 'label') ? '' : ' x 1/' + denom))
					);
			case 'percent':
				switch (format.labelMode) {
					case 'both':
					case 'value':
						return '' + Number(value).toFixed(fixed) + '%';
					default:
						return '' + Number(value).toFixed(fixed);
				}
		}
	}
	static FromString(value: string, format: FractionalValue, asFloat: boolean = false): number {
		switch (format.mode) {
			case 'convert':
				const wholeFrac = value.trim().split(' ');
				const whole = Number(wholeFrac.shift());
				const frac = wholeFrac.shift();
				const fracParts = frac.split('/');
				const modulus = Number(fracParts.shift());
				let numberVal = Number(whole);
				for (const part of fracParts) {
					if (Number(part) === 0) {
						continue;
					}
					numberVal = numberVal * Number(part);
				}
				numberVal += modulus;
				return numberVal;
			case 'numerator':
				const parts = value.split('/');
				const numerator = parts.shift();
				return Number(numerator);
			case 'percent':
				const pct: number = parseInt(value, 10);
				if (asFloat === true) {
					return pct / 100;
				} else {
					return pct;
				}
		}
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberFractionQualifierService.ToString(val, casting.fractional, casting.fixedDigits);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null].indexOf(val) > -1) {
			return '';
		}
		return NumberFractionQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		const casting: CastingValue = attribute.casting[castingMode];
		return NumberFractionQualifierService.FromString(value, casting.fractional, true);
	}
	public static SupportsStat(statName): boolean {
		return NumberFractionQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat(attribute: AttributeInfo, castingMode: CastingMode): string {
		let casting: CastingValue = null;
		if (!!attribute.casting && !!attribute.casting[castingMode]) {
			casting = attribute.casting[castingMode];
		} else if (!!attribute.casting && !!attribute.casting.entry) {
			casting = attribute.casting.entry;
		} else {
			return '@';
		}
		if (!casting.fractional) {
			return '@';
		}
		const format: FractionalValue = casting.fractional;

		switch (format.mode) {
			case 'convert':
				return ' #/' + format.denom;
			case 'numerator':
				if (format.labelMode !== 'label') {
					return `" x 1/' + format.denom"`;
				} else {
					return ''
				}
			case 'percent':
				if (format.labelMode !== 'label') {
					return '%'
				} else {
					return '';
				}
				break;

		}

	}
	public static GetXlsNum(attribute: AttributeInfo, castingMode: CastingMode, val: number): number {
		let casting: CastingValue = null;
		if (!!attribute.casting && !!attribute.casting[castingMode]) {
			casting = attribute.casting[castingMode];
		} else if (!!attribute.casting && !!attribute.casting.entry) {
			casting = attribute.casting.entry;
		} else {
			return val;
		}
		if (!!casting.fractional) {
			switch (casting.fractional.mode) {
				case 'convert':
					return val / Number(casting.fractional.denom);
				case 'percent':
				case 'numerator':
				default:
					return val;
			}
		}
	}
}